/*
 * @Date         : 2020-03-23 16:40:01
 * @LastEditors  : lihaoqian
 * @LastEditTime : 2020-04-20 20:05:47
 * @FilePath     : /pplp-web-source/src/store/modules/user.js
 */
export default {
  state: {
    isLogin: false,
    userInfo: {},
    pUserInfo: {},
    isVip: false,
    vipInfo: {},
    sportsVipInfo: [],
    balanceAmt: 0,
    isUseYz: false, // 是否使用云钻
    coupons: {}, // 优惠券/代金券 信息
    monthlyInfo: [], // 包月信息
  },
  mutations: {
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo.userInfo;
      state.isLogin = userInfo.isLogin;
    },
    updatepUserInfo(state, pUserInfo) {
      state.pUserInfo = pUserInfo;
    },
    updateVipInfo(state, vipInfo) {
      state.vipInfo = vipInfo;
    },
    updateSportsVipInfo(state, sportsVipInfo) {
      state.sportsVipInfo = sportsVipInfo;
    },
    updateBalanceAmt(state, balanceAmt) {
      state.balanceAmt = balanceAmt;
    },
    updateIsUseYz(state, isUseYz) {
      state.isUseYz = isUseYz;
    },
    updateCoupons(state, coupons) {
      state.coupons = coupons;
    },
    updateMonthlyInfo(state, monthlyInfo) {
      state.monthlyInfo = monthlyInfo;
    },
    updateInfo(state, arr) {
      this.commit('updateUserInfo', arr[0]);
      this.commit('updatepUserInfo', arr[1]);
      this.commit('updateVipInfo', arr[2]);
      this.commit('updateSportsVipInfo', arr[3]);
    },
  },
};
